export enum UnifiedApiEnum {
  HRIS = 'hris',
  AM = 'am',
  MDM = 'mdm',
  SSO = 'sso',
  ATS = 'ats',
  Shipment = 'shipment',
  Distributor = 'distributors',
}

export const UNIFIED_APIS = Object.entries(UnifiedApiEnum);

export const UnifiedApiEnumNames = {
  [UnifiedApiEnum.HRIS]: 'HRIS',
  [UnifiedApiEnum.AM]: 'AM',
  [UnifiedApiEnum.MDM]: 'MDM',
  [UnifiedApiEnum.SSO]: 'SSO',
  [UnifiedApiEnum.ATS]: 'ATS',
  [UnifiedApiEnum.Shipment]: 'Shipment',
  [UnifiedApiEnum.Distributor]: 'Distributor',
};
